import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-background-50/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <span className="text-background-50 font-bold text-sm">糖</span>
              </div>
              <span className="text-lg font-bold text-background-50">糖心传媒</span>
            </Link>
            <p className="text-sm leading-relaxed">
              专注品牌内容创作与数字营销的专业传媒机构，助力品牌突破流量瓶颈，实现精准曝光与用户转化增长。
            </p>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4">核心服务</h4>
            <ul className="space-y-2.5">
              <li><a href="/category/short-video" className="text-sm hover:text-background-50 transition-colors">短视频制作</a></li>
              <li><a href="/category/social-media" className="text-sm hover:text-background-50 transition-colors">社交媒体运营</a></li>
              <li><a href="/category/kol" className="text-sm hover:text-background-50 transition-colors">KOL合作</a></li>
              <li><a href="/category/full-case" className="text-sm hover:text-background-50 transition-colors">全案策划</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li><Link to="/category/all" className="text-sm hover:text-background-50 transition-colors">案例洞察</Link></li>
              <li><Link to="/about" className="text-sm hover:text-background-50 transition-colors">关于我们</Link></li>
              <li><Link to="/about" className="text-sm hover:text-background-50 transition-colors">合作咨询</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4">联系我们</h4>
            <ul className="space-y-2.5 text-sm">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5"></i>
                <span>hello@tangxinmedia.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line mt-0.5"></i>
                <span>400-888-9999</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5"></i>
                <span>上海市静安区南京西路1788号</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs">
            &copy; {currentYear} 糖心传媒 TangXin Media. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-xs hover:text-background-50 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs hover:text-background-50 transition-colors" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs hover:text-background-50 transition-colors" rel="nofollow">网站地图</a>
          </div>
        </div>
      </div>
    </footer>
  );
}